import { api } from '@/lib/api'
import type { HaloUser, HaloUserListResponse } from './types'

export async function listHaloUsers(params: {
  active?: boolean
  search?: string
  offset?: number
  limit?: number
}): Promise<HaloUserListResponse> {
  const res = await api.get<HaloUserListResponse>('/api/halocrm-users', {
    params: {
      active: params.active ?? true,
      search: params.search?.trim() || undefined,
      offset: params.offset ?? 0,
      limit: params.limit ?? 50,
    },
  })
  return res.data
}

export async function getHaloUser(id: number): Promise<HaloUser> {
  const res = await api.get<HaloUser>(`/api/halocrm-users/${id}`)
  return res.data
}

export async function triggerHaloUserSync(): Promise<{ upserted: number; markedInactive: number }> {
  const res = await api.post<{ upserted: number; markedInactive: number }>(
    '/api/admin/halocrm-users/sync',
  )
  return res.data
}
